import { TUTORIAL_ADDING_TEXTS } from 'constants/tutorials';
import getTutorialCovers from './getTutorialCovers';

export default getTutorialCovers(TUTORIAL_ADDING_TEXTS);
